/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type EnumEntriesLetterPlaceholderItem =
  (typeof EnumEntriesLetterPlaceholderItem)[keyof typeof EnumEntriesLetterPlaceholderItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumEntriesLetterPlaceholderItem = {
  PATIENT_NAME: 'PATIENT_NAME',
  PATIENT_BIRTHDAY: 'PATIENT_BIRTHDAY',
  PATIENT_CASE_NUMBER: 'PATIENT_CASE_NUMBER',
  PATIENT_NATIONALITY: 'PATIENT_NATIONALITY',
  PATIENT_RESIDENCE_ORGANIZATION: 'PATIENT_RESIDENCE_ORGANIZATION',
  PATIENT_RESIDENCE_STREET: 'PATIENT_RESIDENCE_STREET',
  PATIENT_RESIDENCE_CITY: 'PATIENT_RESIDENCE_CITY',
  PATIENT_PHONE: 'PATIENT_PHONE',
  EMPLOYEE_NAME: 'EMPLOYEE_NAME',
  EMPLOYEE_EMAIL: 'EMPLOYEE_EMAIL',
  GENERAL_DATE: 'GENERAL_DATE',
} as const;
